import { SlingoEvent } from "@lib/titan2-slingo/dist/game/controller/event/SlingoEvent";
import { TicketController } from "@lib/titan2-slingo/dist/game/controller/TicketController";
import { FreeSpinReelControllerEvent, TicketViewEvent } from "./event/GameEvent";
import { FreeSpinReelState } from "../model/GameModel";
import { GameState } from "@lib/titan2-slingo/dist/api/model/enum/GameState";
export class GameTicketController extends TicketController {
    addEventListeners() {
        super.addEventListeners();
        this.registerGame(FreeSpinReelControllerEvent.FREE_SPIN_TRANSITION_IN_COMPLETE, this.notifyDabComplete);
        this.registerGame(FreeSpinReelControllerEvent.FREE_SPIN_RETRIGGER_COMPLETE, this.notifyDabComplete);
    }
    handleDabComplete() {
        const spin = this.model.getSpinResult();
        const freeSpinIndexes = spin.getReelSequence().getFreeSpinIndexes();
        if (freeSpinIndexes.length <= 0 || this.model.getState() === GameState.COMPLETE) {
            this.notifyDabComplete();
            return;
        }
        if (this.model.getFreeSpinReelState() === FreeSpinReelState.STANDARD_REEL) {
            this.dispatchGame(FreeSpinReelControllerEvent.FREE_SPIN_TRANSITION_IN_START);
        }
        else {
            this.dispatchGame(FreeSpinReelControllerEvent.FREE_SPIN_RETRIGGER_START);
        }
    }
    notifyDabComplete() {
        this.dispatchGame(SlingoEvent.DAB_COMPLETE);
    }
    createModel() {
        super.createModel();
        this.model = this.baseModel;
    }
    matchPatterns(matchSlingos) {
        let dabData = this.model.getDabData();
        let progress = this.model.getGameProgress();
        let payoutConfig = this.model.getPayoutConfig();
        let patterns = payoutConfig.getPatterns();
        let matchedPatterns = this.model.getMatchedPatterns();
        let winningPatterns = [];
        for (let i = 0; i < patterns.length; i++) {
            let pattern = patterns[i];
            let key = pattern.getKey();
            if (!matchedPatterns.containsKey(key)) {
                if (this.matchPattern(pattern)) {
                    matchedPatterns.setValue(key, pattern);
                    winningPatterns.push(pattern);
                }
            }
        }
        // PH Defensive sanity check for matched patterns
        let numberOfMatchedPatterns = Math.min(matchedPatterns.size(), progress.getMatchedPatterns());
        this.model.setCurrentMatchedPatterns(numberOfMatchedPatterns);
        let hasMatched = false;
        if (matchSlingos) {
            let numberOfSlingos = winningPatterns.length;
            hasMatched = numberOfSlingos > 0;
            if (hasMatched) {
                this.model.setSlingoPatterns(winningPatterns);
                dabData.slingoSuccess(numberOfSlingos);
                this.model.setSlingoInProgress(true);
                this.dispatchGame(TicketViewEvent.SLINGO_TICKET_ANIMATION);
            }
        }
        return hasMatched;
    }
}
//# sourceMappingURL=GameTicketController.js.map